import { FC } from 'react'
import { PageContent, PageLayout } from '@reapitform/dashboard-ui'
import LoginAndSecuritySection from './view/login-and-security-section'
import PersonalInformationSection from './view/personal-information-section'
import PrivacyAndSecurityInformationSection from './view/privacy-and-security-information'
import { css } from '@linaria/core'

const profilePageLayoutStyle = css`
  flex-direction: column;
  flex-grow: 1;
  flex-wrap: nowrap;
`

const ProfilePage: FC = () => {
  return (
    <PageLayout pageTitle="Profile" className={profilePageLayoutStyle}>
      <PageContent>
        <LoginAndSecuritySection />
        <PersonalInformationSection />
      </PageContent>
      <PrivacyAndSecurityInformationSection />
    </PageLayout>
  )
}

export default ProfilePage
